var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginOrigin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.332c-3.673 0-6.667 2.993-6.667 6.667 0 3.673 2.994 6.666 6.667 6.666 3.673 0 6.667-2.993 6.667-6.666 0-3.674-2.994-6.667-6.667-6.667zm0 12a5.34 5.34 0 01-5.333-5.333A5.34 5.34 0 018 2.665 5.34 5.34 0 0113.333 8 5.34 5.34 0 018 13.332zm2-5.333c0 1.106-.893 2-2 2s-2-.894-2-2c0-1.107.893-2 2-2s2 .893 2 2z",
    fill: "#CACACA"
  })));
}
export default SvgLoginOrigin;